"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var button = function button(theme) {
  return /*#__PURE__*/(0, _react.css)("min-width:", (0, _util.rem)(240), ";justify-content:left;&:hover{border-color:", theme.color.dropdownButton.borderHover, ";}&:active{background-color:", theme.color.monochrome.white, ";}&:focus{border-color:", theme.color.dropdownButton.borderFocus, ";}&+*{width:auto!important;}" + (process.env.NODE_ENV === "production" ? "" : ";label:button;"));
};

var indicator = function indicator(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(40), ";height:100%;background-color:", theme.color.monochrome.superLight, ";display:inline-block;position:absolute;right:0;top:0;padding:", (0, _util.rem)(7), ";border-left:1px solid ", theme.color.buttonTertiary.border, ";&>span{width:100%;height:100%;display:inline-block;border-radius:", (0, _util.rem)(4), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:indicator;"));
};

var popover = /*#__PURE__*/(0, _react.css)(".sketch-picker{width:", (0, _util.rem)(220), "!important;box-shadow:none!important;border-radius:0!important;}" + (process.env.NODE_ENV === "production" ? "" : ";label:popover;"));
var styles = {
  button: button,
  indicator: indicator,
  popover: popover
};
exports.styles = styles;
//# sourceMappingURL=ColorPicker.styles.js.map